import { render, staticRenderFns } from "./IndustryFilter.vue?vue&type=template&id=f5472030&scoped=true&"
import script from "./IndustryFilter.vue?vue&type=script&lang=ts&"
export * from "./IndustryFilter.vue?vue&type=script&lang=ts&"
import style0 from "./IndustryFilter.vue?vue&type=style&index=0&id=f5472030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5472030",
  null
  
)

export default component.exports